'use client';

import { useEffect, type FC } from 'react';
import { ErrorSwatch } from '../ErrorSwatch';

export interface IFailedHexValidationProps {
  /** The error from the failed hex validation. */
  error: unknown;
  /** The SKU of the product variation for logging purposes. */
  sku: string;
}

/** Renders an error swatch and logs a warning to the console when the hex value is invalid. */
export const FailedHexValidation: FC<IFailedHexValidationProps> = ({
  error,
  sku
}) => {
  useEffect(() => {
    console.warn(`Swatch error for SKU "${sku}"`, error);
  }, [error, sku]);

  const errorMessage = error instanceof Error ? error.message : String(error);
  return <ErrorSwatch errorMessage={errorMessage} />;
};
